import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { YES, NO } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step19: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearProjectsInfo = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("projectType", []);
      formik.setFieldValue("projectRequeriments", []);
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "hasPersonalProject",
      questionData: questions[0],
      elementType: ElementType.Radio,
      onChangeCallback: clearProjectsInfo,
      label: "¿Tiene algún proyecto/meta a corto plazo (uno o dos años)?",
    },
    {
      key: 1,
      formik,
      name: "projectType",
      label: "¿De qué tipo?",
      elementType: ElementType.Checkbox,
      questionData: questions[0]?.subQuestions[0],
      visible: formik?.values?.hasPersonalProject?.value === YES,
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 1rem",
      },
    },
    {
      key: 2,
      formik,
      name: "projectRequeriments",
      elementType: ElementType.Checkbox,
      label: "¿Qué le hace falta para cumplirlo?",
      questionData: questions[0]?.subQuestions[1],
      visible: formik?.values?.hasPersonalProject?.value === YES,
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 1rem",
      },
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "needsOrConcerns",
      elementType: ElementType.Checkbox,
      questionData: questions[1],
      label: "¿En qué aspecto de su vida tiene mayor necesidades o preocupaciones?",
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 1rem",
      },
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Cuéntenos sobre sus proyectos y metas
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step19;
